export default function TotalAmountIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.33337"
        y="4.6665"
        width="23.3333"
        height="18.6667"
        rx="4"
        stroke="#455468"
        stroke-width="1.5"
      />
      <path
        d="M19 12.0214V13.1749H13.1156V17.5968C13.1156 18.0988 13.1837 18.4406 13.3197 18.6222C13.4671 18.8037 13.7506 18.8945 14.1701 18.8945C14.5102 18.8945 14.8503 18.8251 15.1905 18.6862C15.542 18.5474 15.8537 18.3605 16.1259 18.1255C16.4093 17.8905 16.6361 17.6235 16.8061 17.3244C16.9762 17.0147 17.0612 16.6996 17.0612 16.3792C17.0612 16.1228 16.9819 15.9252 16.8231 15.7864C16.6757 15.6475 16.432 15.5781 16.0918 15.5781C15.7857 15.5781 15.5023 15.6101 15.2415 15.6742L15.0714 14.5848C15.2642 14.5314 15.4683 14.494 15.6837 14.4726C15.9104 14.4406 16.1372 14.4246 16.3639 14.4246C16.9649 14.4246 17.4524 14.5688 17.8265 14.8571C18.212 15.1348 18.4048 15.5888 18.4048 16.219C18.4048 16.7103 18.28 17.1856 18.0306 17.6449C17.7925 18.0935 17.4694 18.4993 17.0612 18.8625C16.6531 19.215 16.1939 19.4927 15.6837 19.6956C15.1735 19.8985 14.6519 20 14.119 20C13.6995 20 13.3537 19.9573 13.0816 19.8718C12.8095 19.7757 12.5828 19.6475 12.4014 19.4873C12.288 19.3805 12.1859 19.263 12.0952 19.1348C12.0045 18.996 11.9308 18.8144 11.8741 18.5901C11.8288 18.3551 11.8061 18.0454 11.8061 17.6609V13.1749H10.1565V12.0214H19ZM11.0068 8C11.3356 8 11.619 8.04272 11.8571 8.12817C12.1066 8.21362 12.3163 8.34179 12.4864 8.51268C12.6905 8.71562 12.8435 8.99332 12.9456 9.34579C13.059 9.68758 13.1156 10.1736 13.1156 10.8037V12.1495H11.8061V10.8678C11.8061 10.494 11.7778 10.1842 11.7211 9.93858C11.6757 9.68224 11.568 9.48999 11.398 9.36182C11.2279 9.22296 10.9728 9.15354 10.6327 9.15354C10.4172 9.15354 10.2018 9.18558 9.98639 9.24967C9.78231 9.30307 9.60658 9.35648 9.45918 9.40988L9 8.41655C9.34014 8.2777 9.66893 8.17623 9.98639 8.11215C10.3152 8.03738 10.6553 8 11.0068 8Z"
        fill="#455468"
      />
    </svg>
  );
}
